import React, { FunctionComponent } from 'react'
import Svg, { Circle, Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'
export interface AuroraCheckMarkIconProps {
  size?: number
  fillColor?: string
  strokeColor?: string
  testID?: string
}

/**
 * Aurora-themed checkmark icon with circular background
 */
export const AuroraCheckMarkIcon: FunctionComponent<AuroraCheckMarkIconProps> = ({
  size = 16,
  fillColor,
  strokeColor,
  testID = 'AuroraCheckMarkIcon',
}) => {
  const { colors } = useTheme() as AuroraThemeType
  const { checkMarkIcon } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 16 16' fill='none' testID={testID}>
      <Circle cx='8' cy='8' r='8' fill={fillColor || checkMarkIcon.fill} fillOpacity='0.2' />
      <Path
        d='M5 8L7 10L11 6'
        stroke={strokeColor || fillColor || checkMarkIcon.fill}
        strokeWidth='1.66667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  )
}
